import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNiger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1418)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.19072 6.78262C0.427875 8.36025 0 10.1301 0 12C0 13.8699 0.427875 15.6397 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6397 24 13.8699 24 12C24 10.1301 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.19114 17.2174C3.13204 21.2313 7.24247 24 12 24C16.7575 24 20.8679 21.2313 22.8088 17.2174H1.19114Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.19114 6.78263H22.8088C20.8679 2.76867 16.7575 0 12 0C7.24251 0 3.13204 2.76867 1.19114 6.78263Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 9.69483 14.3052 7.82611 12 7.82611C9.69483 7.82611 7.82611 9.69483 7.82611 12C7.82611 14.3052 9.69483 16.1739 12 16.1739Z",
				fill: "#FF9811"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1418",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNiger;
